import { MediaFile, OwnerUser } from "..";

export interface AddNewDocument {
  proposedPropertyIds: any[];
  documentCategory: string;
  documentSubCategory?: string;
  ownerOfDocument?: string;
  documentName?: string;
}

export enum RequiredDocumentStatus {
  Pending = "Pending",
  Draft = "Draft",
  Requested = "Requested",
  Sent = "Sent",
  Expired = "Expired",
  Rejected = "Rejected",
  Accepted = "Accepted",
}

export enum DocumentUserType {
  Client = "Client",
  VendorOwner = "Vendor/Owner",
}

export interface LegalDueDiligences {
  attributes: any;
  documentType: string;
  _id?: string;
  documentCategory?: string;
  subCategory?: string;
  ownerOfDocument?: string;
  documentName?: string;
  status: RequiredDocumentStatus;
  versionNumber?: number;
  proposedPropertyId?: string;
  proposalId?: string;
  masterRequirementId?: string;
  createdBy: OwnerUser;
  document: MediaFile;
  uploadedBy: OwnerUser;
  uploadedAt?: Date;
  createdAt?: Date;
  documentSubmittedDate?: Date;
  expiryAt?: Date;
  documentUploadedDate?: Date;
}

export interface LegalDueDiligencesData {
  legalDueDiligences?: LegalDueDiligences[];
  requestedHistory?: DocumentActionHistory[];
  sentHistory?: SentHistory[];
}

export interface DocumentActionHistory {
  _id?: string;
  action: string;
  content: string;
  documentName?: string;
  status: RequiredDocumentStatus;
  versionNumber?: number;
  proposedPropertyId?: string;
  legalDueDiligenceId?: string;
  masterRequirementId?: string;
  uploaddoneByedBy: OwnerUser;
  doneTo?: OwnerUser[];
  doneToUserType: DocumentUserType;
}

export interface SentHistory {
  _id?: string;
  documentCategory?: string;
  subCategory?: string;
  ownerOfDocument?: string;
  documentName?: string;
  status: RequiredDocumentStatus;
  versionNumber?: number;
  proposedPropertyId?: string;
  legalDueDiligenceId?: string;
  masterRequirementId?: string;
  uploaddoneByedBy: OwnerUser;
  doneTo?: OwnerUser[];
  doneToUserType: DocumentUserType;
}
